// HistoryItemPlacehholder.js
import React from 'react';
export default function HistoryItemPlaceholder() {
  return (
    <div className={`history-item -placeholder`}>
      <div className="loading-message">
        loading ...
      </div>
      {/*<div className="history-header">*/}
      {/*  <span className="avatar" />*/}
      {/*  <span className="duration">⏱</span>*/}
      {/*</div>*/}
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/moodboard_ai_requests/HistoryItemPlaceholder.js